import { useEffect } from 'react';
import { FeatureLayout, RoundedButton } from '@lendica/components';
import { Box, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { RunningWithErrors } from '@mui/icons-material';
import { emitApi } from '@lendica/api';
import { useCompanyNavigate } from '@lendica/hooks';

export const ExceededLimit = () => {
    const navigate = useCompanyNavigate();
    useEffect(() => {
        emitApi.dealExceedsLimit();
    }, []);

    return (
        <FeatureLayout>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    height: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    boxSizing: 'border-box',
                    px: 4,
                }}
            >
                <RunningWithErrors color="warning" style={{ fontSize: 80 }} />
                <Typography variant="h5" sx={{ mt: 4 }}>
                    You have exceeded your credit limit.
                </Typography>

                <RoundedButton
                    size="medium"
                    startIcon={<ArrowBackIcon />}
                    sx={{ mt: 4, mx: 2 }}
                    onClick={() => navigate('/fundnow')}
                >
                    Go Back
                </RoundedButton>
            </Box>
        </FeatureLayout>
    );
};
